import { zIndex } from '@/theme/zIndex';
import type { ModalLayerZIndices } from './modal-stack-types';

const MODAL_LAYER_BASE = zIndex.modalLayerBase;
const MODAL_LAYER_STEP = zIndex.modalLayerStep;

export function modalLayerZIndices(visualIndex: number): ModalLayerZIndices {
  const layerBase = MODAL_LAYER_BASE + Math.max(0, visualIndex) * MODAL_LAYER_STEP;
  return { backdrop: layerBase, underlay: layerBase + 1, content: layerBase + 2 };
}
